/* REACT */
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

/* HOOKS */
import useInsert from "../../../hooks/useInsert";
import useScroll from '../../../hooks/useScroll';

/* FUNCTIONS */
import ImageCapture from '../../../components/ImageCapture';


/* COMPONENTS */


/* LIBRARIES */
import DatePicker from "react-datepicker";
import Swal from 'sweetalert2';
import { v4 as uuidv4 } from 'uuid'; 
/* END LIBRARIES */




 
  const stripTime = (date) => {
    return  date ? date.toISOString().split('T')[0] : ""; 
  };

  const formatDate = (date) => {
    const newDate = new Date(date);
    return newDate.toISOString().split('T')[0]; // Format to YYYY-MM-DD
  };

const TechOathAmplifyAdd = () => {

    const { insertData, isLoading, errorMessage, successMessage, responseData } = useInsert();

    const [stayingSince, setStayingSince] = useState(null);
    const handleDateChangeStayingSince = (date) => {
        setStayingSince(date);
      };


    const [dateOfDeath, setDateOfDeath] = useState(null);
    const handleDateChangeDateOfDeath = (date) => {
        setDateOfDeath(date);
      };


      const [familyHomeFathersName,setFamilyHomeFathersName]   = useState("")
      const [familyHomeFathersBday,setFamilyHomeFathersBday]   = useState("")
      const [familyHomeMothersName,setFamilyHomeMothersName]   = useState("")
      const [familyHomeMothersBday,setFamilyHomeMothersBday] = useState("")
      const [familyHomeAddress,setFamilyHomeAddress]           = useState("")


    const { category } = useParams();

    const { activeIndex, executeScroll } = useScroll(0);


    const [cachedData, setCachedData] = useState([]);

    useEffect(() => {
        const cachedDataString = localStorage.getItem('cachedData');
        if (cachedDataString) {
            const parsedCachedData = JSON.parse(cachedDataString);
            setCachedData(parsedCachedData);
        }
    }, []);



    // BALIK PROBINSYA DATA
    const [provinceList, setProvinceList] = useState([]);  
      useEffect(() => {
        // GETTING ALL PROVINCES ONLY
        const uniqueProvinces = [...new Set(cachedData.map(location => location.location_province))];
        const sortedProvinces = uniqueProvinces.sort();

        setProvinceList(sortedProvinces);
    }, [cachedData]);



    const [balikProbinsyaAddressProvince,setBalikProbinsyaAddressProvince] = useState("");
    const [balikProbinsyaAddress,setBalikProbinsyaAddress] = useState("");


    const [transferAddress,setTransferAddress] = useState("");


    const [nativeOf,setNativeOf] = useState("");
    const [reasonOfStaying,setReasonOfStaying] = useState("");
    
    



    const links = [
        { label: 'Client details', iconClass: 'bx bxs-credit-card' },
        { label: 'Relationship', iconClass: 'bx bx-cart' },
        { label: 'Beneficiary details', iconClass: 'bx bxs-credit-card' },
        { label: 'Request Information', iconClass: 'bx bx-package' },
    ];



    const handleConfirmation = async () => {
        const result = await Swal.fire({
            title             : 'Are you sure?',
            text              : 'Do you want to proceed?',
            icon              : 'warning',
            showCancelButton  : true,
            confirmButtonColor: 'btn-info',
            cancelButtonColor : 'btn-secondary',
            confirmButtonText : 'Yes, proceed!',
            cancelButtonText  : 'No, cancel',
            confirmButtonColor: '#03c3ec',
            cancelButtonColor: '#ff3e1d',
        });

        if (result.isConfirmed) {
            const formData = {
                relationship_to_beneficiary: relationshipToBeneficiary,
                ss_type: category,
                ...clientFormData,
                ...beneficiaryFormData,
                ...requestData
            };

            try {
                await insertData(`${process.env.REACT_APP_API_URL}/socialservice/`, formData);
            } catch (error) {
                console.error("Error inserting data:", error);
            }

            // Navigate or perform other actions here
        } else if (result.dismiss === Swal.DismissReason.cancel) {
            // Handle cancellation if needed
        }

    };


    // IF THERE;S AN ERROR SCROLL TO TOP ALWAYS TO SHOW ERROR LISTS
    useEffect(() => {
        if (errorMessage) {
            setTimeout(() => {
                scrollToTop();
            }, 750);
        }
    }, [errorMessage])

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };





    // Define state variables for form data for client and beneficiary
    const [clientFormData, setClientFormData] = useState({
        // Initialize with default values for client
        client_fullname    : "",
        client_isVoter     : "",
        client_voter_id    : "",
        client_email       : "",
        client_contact     : "",
        client_gender      : "",
        client_birthdate   : "",
        client_address     : "",
        client_district    : "",
        client_municipality: "",
        client_barangay    : "",
        client_sitio       : "",
        client_sector      : "",
        client_father_name : "",
        client_mother_name : "",
        client_family_id   : "",
        client_family_role : "",

        client_civil_status  : "",
        client_place_of_birth: "",
    });

    const [relationshipToBeneficiary, setRelationshipToBeneficiary] = useState("");


    const [remarks, setRemarks] = useState("");

 

    const [beneficiaryFormData, setBeneficiaryFormData] = useState({
        // Initialize with default values for beneficiary
        beneficiary_fullname      : "",
        beneficiary_isVoter       : "",
        beneficiary_voter_id      : "",
        beneficiary_email         : "",
        beneficiary_contact       : "",
        beneficiary_gender        : "",
        beneficiary_birthdate     : "",
        beneficiary_address       : "",
        beneficiary_district      : "",
        beneficiary_municipality  : "",
        beneficiary_barangay      : "",
        beneficiary_sitio         : "",
        beneficiary_family_id     : "",
        beneficiary_family_role   : "",
        beneficiary_civil_status  : "",
        beneficiary_place_of_birth: "",
    });


    const [requestData, setRequestData] = useState({
        amount: "",
        date_request: new Date(),
        status: "",
        remarks: ""
    });





    // Update form data when child component changes its state
    const handleClientChange = (clientData) => {
        setClientFormData(prevData => ({
            ...prevData,
            ...clientData
        }));
    };

    const handleBeneficiaryChange = (beneficiaryData) => {

        setBeneficiaryFormData(prevData => ({
            ...prevData,
            ...beneficiaryData
        }));

    };


    const handleRelationshipChange = (e) => {
        setRelationshipToBeneficiary(e.target.value);
    };

    const handleRequestChange = (e) => {
        const { name, value } = e.target;
        setRequestData(prevData => ({
            ...prevData,
            [name]: value
        }));
    };


    const [capturedImage, setCapturedImage] = useState(null);

    const handleImageChange = (image) => {
        setCapturedImage(image);
    };

 

    
    const [certificateType, setCertificateType] = useState("");
    const [amount, setAmount]                   = useState(parseFloat(0.00));
    const [discount, setDiscount]               = useState(parseFloat(0.00));

   


    // const [isLoading, setIsLoading] = useState(false);

    const navigate = useNavigate();



    const handleSubmit = async (e) => {
        e.preventDefault();
        let formField = new FormData();
 

        formField.append("cert_no", "");
        formField.append("cert_for", requestFor);
        formField.append("cert_purpose", certPurpose);
        formField.append("cert_type", certificateType);
        formField.append("cert_amount", amount);
        formField.append("cert_discount", discount);

        
        formField.append("cert_requested_at", "");
        formField.append("cert_requested_by", "");
        
        formField.append("cert_released_at", "");
        formField.append("cert_released_by", "");
 
        formField.append("client_fullname",clientFormData.client_fullname);
        formField.append("client_isVoter",clientFormData.client_isVoter);
        formField.append("client_voter_id",clientFormData.client_voter_id);
        formField.append("client_email",clientFormData.client_email);
        formField.append("client_contact",clientFormData.client_contact);
        formField.append("client_gender",clientFormData.client_gender);
        formField.append("client_birthdate",clientFormData.client_birthdate);
        formField.append("client_address",clientFormData.client_address);
        formField.append("client_district",clientFormData.client_district);
        formField.append("client_municipality",clientFormData.client_municipality);
        formField.append("client_barangay",clientFormData.client_barangay);
        formField.append("client_sitio",clientFormData.client_sitio);
        formField.append("client_family_id",clientFormData.client_family_id);
        formField.append("client_family_role",clientFormData.client_family_role);
        formField.append("client_civil_status",clientFormData.client_civil_status);
        formField.append("client_place_of_birth",clientFormData.client_place_of_birth);

        formField.append("beneficiary_fullname",beneficiaryFormData.beneficiary_fullname);
        formField.append("beneficiary_isVoter",beneficiaryFormData.beneficiary_isVoter);
        formField.append("beneficiary_voter_id",beneficiaryFormData.beneficiary_voter_id);
        formField.append("beneficiary_email",beneficiaryFormData.beneficiary_email);
        formField.append("beneficiary_contact",beneficiaryFormData.beneficiary_contact);
        formField.append("beneficiary_gender",beneficiaryFormData.beneficiary_gender);
        formField.append("beneficiary_birthdate",beneficiaryFormData.beneficiary_birthdate);
        formField.append("beneficiary_address",beneficiaryFormData.beneficiary_address);
        formField.append("beneficiary_district",beneficiaryFormData.beneficiary_district);
        formField.append("beneficiary_municipality",beneficiaryFormData.beneficiary_municipality);
        formField.append("beneficiary_barangay",beneficiaryFormData.beneficiary_barangay);
        formField.append("beneficiary_sitio",beneficiaryFormData.beneficiary_sitio);
        formField.append("beneficiary_family_id",beneficiaryFormData.beneficiary_family_id);
        formField.append("beneficiary_family_role",beneficiaryFormData.beneficiary_family_role);
        formField.append("beneficiary_civil_status",beneficiaryFormData.beneficiary_civil_status);
        formField.append("beneficiary_place_of_birth",beneficiaryFormData.beneficiary_place_of_birth);


        formField.append("year_of_residency", residentSince);
        formField.append("year_of_partnership", partnertSince);
        formField.append("cohabitation_address", cohabitationAddress);


        

        

        formField.append("relationship_to_beneficiary", relationshipToBeneficiary);
        formField.append("remarks", remarks);

        formField.append("requestor_is_beneficiary", isRequestorABeneficiary);

        formField.append("balik_probinsya_address", balikProbinsyaAddress);
        formField.append("balik_probinsya_address_province", balikProbinsyaAddressProvince);

        formField.append("transfer_address", transferAddress);

        formField.append("visa_native_of", nativeOf);
        formField.append("visa_reason_of_staying", reasonOfStaying);
        formField.append("visa_staying_since", stayingSince);


        formField.append("date_of_death", dateOfDeath);



        formField.append("family_home_fathers_name", familyHomeFathersName);
        formField.append("family_home_fathers_bday", familyHomeFathersBday);
        formField.append("family_home_mothers_name", familyHomeMothersName);
        formField.append("family_home_mothers_bday", familyHomeMothersBday);
        formField.append("family_home_address", familyHomeAddress);


        
        let keysToRemove = [
            'id',
            'bp_beneficiary_isVoter',
            'bp_beneficiary_family_id',
            'bp_beneficiary_family_role',
            'bp_beneficiary_household_id',
            'bp_beneficiary_household_role',
            'bp_beneficiary_government_position',
            'bp_beneficiary_voter_cluster_number',
            'bp_beneficiary_voter_clustered_polling_place',
            'bp_beneficiary_voter_clustered_precinct',
            'bp_beneficiary_voter_id_status',
            'bp_beneficiary_voter_image_path',
            'bp_beneficiary_voter_leader',
            'bp_beneficiary_voter_org',
            'bp_beneficiary_voter_org_2',
            'bp_beneficiary_voter_poll_watcher_workers',
            'bp_beneficiary_voter_religion',
            'bp_beneficiary_voter_sector',
            'bp_beneficiary_voter_status',
            'bp_beneficiary_voter_structure_code',
            'bp_beneficiary_voter_structure_name',
            'bp_beneficiary_voter_vital_status',
            'bp_beneficiary_voter_working_status'
        ];


        let filteredArray = forms.map(obj => {
            // Filter out unwanted keys
            let filteredObject = {};
            Object.keys(obj).forEach(key => {
                if (!keysToRemove.includes(key)) {
                    filteredObject[key] = obj[key];
                }
            });
            return filteredObject;
        });
        

        formField.append("balik_probinsya_members", JSON.stringify(filteredArray));



        

        



        // const fileInput = fileInputRef.current;
        // const files = fileInput.files;
    
        // if (fileInput && files.length > 0) {
        //   for (let i = 0; i < files.length; i++) {
        //     formField.append("image", files[i]);
        //   }
        // } else if (capturedImage) {
        //   formField.append("image", image);
        // }

        if (capturedImage) {
            formField.append('image', capturedImage);
        }
    

       
        const result = await Swal.fire({
            title             : 'Are you sure ?',
            text              : 'Do you want to proceed ?',
            icon              : 'warning',
            showCancelButton  : true,
            confirmButtonColor: 'btn-info',
            cancelButtonColor : 'btn-secondary',
            confirmButtonText : 'Yes, proceed!',
            cancelButtonText  : 'No, cancel',
            confirmButtonColor: '#03c3ec',
            cancelButtonColor: '#ff3e1d',
        });
 
        if (result.isConfirmed) {
            try {
                await insertData(`${process.env.REACT_APP_API_URL}/certificate/`, formField, () => {
                    // IF NO ERROR THEN NAVIGATE
                    navigate('/certificates/');
                });
              } catch (error) {
                console.error("Error inserting data:", error);
              }
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            console.log('Submission cancelled.');
          }
 

    }

    const [residentSince,setResidenceSince] = useState("");
    const handleResidentChange = (value) => {
        setResidenceSince(value)
    }

// COHABITATION
    const [partnertSince,setPartnerSince] = useState("");
    const handlePartnerChange = (value) => {
        setPartnerSince(value)
    }

    const [cohabitationAddress,setCohabitationAddress] = useState('');


    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: currentYear - 1900 + 1 }, (_, index) => 1900 + index);


 
    const [certPurpose, setCertPurpose] = useState("");
    const [noRelationship, setNoRelationship] = useState(false);

    const [noClient,setNoclient] = useState(true);
    const handleCertificate = (e) => {
        let value =  e.target.value;
        setCertificateType(value);
        
        setCertPurpose("");
        setRequestFor("");
        setFinalPurpose([]);
        setNoclient(true);
        setNoPhoto(true);
        setNoRelationship(true);
        
        if(value.toLowerCase()=="barangay clearance"){
            setNoclient(true);
            setNoPhoto(false);
            setFinalPurpose(barangay_clearance_purpose);
        }
        else if (value.toLowerCase()=="barangay indigency") {
            setNoPhoto(true);
            setFinalPurpose(barangay_indigency_purpose);
        }

        else if (value.toLowerCase()=="certificate of residency") {
            setNoPhoto(true);
            setFinalPurpose(certificate_of_residency_purpose);
        }

        else if (value.toLowerCase()=="certification") {
            setNoPhoto(true);
            setFinalPurpose(certification_purpose);
        }

        else if (value.toLowerCase()=="estate tax") {
            setRequestFor("self");
            setNoPhoto(true);
            setFinalPurpose(estate_tax_purpose);
        }
        
    }
 

    const handleCertPurpose = (e) => {
        let value = e.target.value;
        setCertPurpose(value);
        if(value.toLowerCase()=="estate tax residency"){
            setRequestFor("other");
            setNoclient(false);
        }
        else if(value.toLowerCase()=="family home"){
            setRequestFor("self");
            setNoclient(true);
            setNoRelationship(true);
        }

        else if(value.toLowerCase()=="cohabitation"){
            setRelationshipToBeneficiary('Live-in Partner');
        }
        else if(value.toLowerCase()=="balik probinsya"){
            setRequestFor("self");
        }
    }
      


    // HANDLE PHOTO
    const [noPhoto,setNoPhoto] = useState(true);

    const [requestFor,setRequestFor] = useState('');
    const handleOnchangeRequesttFor = (e) => {
        let value = e.target.value;
        setRequestFor(value)
        if(value.toLowerCase()=="other"){
            //setRelationshipToBeneficiary('BENEFICIARY')
            setNoclient(false);
        }
        else{
            setNoclient(true);
            //setRelationshipToBeneficiary('REQUESTOR')
        }

    }

    const [finalPurpose,setFinalPurpose] = useState([]);

    const barangay_clearance_purpose = [
        { purpose: 'FIRST-TIME JOB SEEKER', with_picture: 'false',with_residence_since: 'true'},
        { purpose: 'LATE BIRTH',            with_picture: 'true', with_residence_since: 'true'},
        { purpose: 'LOCAL EMPLOYMENT',      with_picture: 'true', with_residence_since: 'true'},
        { purpose: 'RESIDENCY',             with_picture: 'true', with_residence_since: 'true'},
    ];
    
    const barangay_indigency_purpose = [
        { purpose: 'UNBOUND ELDERLY FOUNDATION'},
        { purpose: 'SWA'},
        { purpose: 'SWA PDAO'},
        { purpose: 'SSDD CAPITAL'},
        { purpose: 'PHILHEALTH'},
        { purpose: 'PAO'},
        { purpose: 'MERALCO LIFELINE DISCOUNT'},
        { purpose: 'MEDICAL FINANCIAL ASST'},
        { purpose: 'DSWD'},
        { purpose: 'DOG BITE'},
        { purpose: 'BURIAL ASSISTANCE'},
        { purpose: 'BALIK PROBINSYA', with_requesting_for:'false', with_beneficiary:'false', with_relationship_to_beneficiary:'false' },
        { purpose: 'DSWD EDUCATIONAL ASSISTANCE'},
        { purpose: 'SCHOLARSHIP (CHED)'},
        { purpose: 'SCHOLARSHIP (QCYDO)'},
        { purpose: 'SCHOLARSHIP APPLICATION'},
        { purpose: 'SCHOLARSHIP APPLICATION (DOST)'},
        { purpose: 'SCHOOL REQUIREMENT'},
        { purpose: 'SCHOLARSHIP (SPES)'},
    ];
    
    const certificate_of_residency_purpose = [
        { purpose: 'PWD ID',    with_picture: 'true', with_residence_since: 'true',with_thumbmark: 'true' },
        { purpose: 'QC ID',     with_picture: 'true', with_residence_since: 'true',with_thumbmark: 'true' },
        { purpose: 'SENIOR',    with_picture: 'true', with_residence_since: 'true',with_thumbmark: 'true' },
    ];
    
    const certification_purpose = [
        { purpose: 'COHABITATION', with_partner_since:'true', with_requesting_for:'true', with_beneficiary:'true', with_relationship_to_beneficiary:'true' },
        { purpose: 'GOOD MORAL'},
        { purpose: 'GUARDIANSHIP CERTIFICATION'},
        { purpose: 'NON RESIDENCY'},
        { purpose: 'NOT COVID TEST'},
        { purpose: 'NOT PUI PUM COVID TEST'},
        { purpose: 'PWD ID',        with_picture: 'true'},
        { purpose: 'SOLO PARENT'},
        { purpose: 'TRANSFER ADDRESS'},
        { purpose: 'VISA EXTENSION'},
    ];
    
    const estate_tax_purpose = [
        { purpose: 'ESTATE TAX RESIDENCY', with_requesting_for:'false'},
        { purpose: 'FAMILY HOME', with_requesting_for:'false', with_relationship_to_beneficiary:'true' },
    ];


    const selectedPurpose = finalPurpose.find(p => p.purpose === certPurpose);


    const formatFieldName = (fieldName) => {
        return fieldName.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
    };





    // FOR BALIK PROBINSYA
    const [forms, setForms] = useState([]);
    const handleAddForm = () => {
        setForms([...forms, {
            id : uuidv4(),
        }]);
    };


      const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const newForms = forms.map((form, formIndex) => {
          if (formIndex === index) {
            return { ...form, [name]: value };
          }
          return form;
        });
        setForms(newForms);
      };

      const handleDeleteForm = (id) => {
        console.log(id);
        if (window.confirm("Are you sure you want to delete this form?")) {
           // Filter out the form with the specified id
          const updatedForms = forms.filter(form => form.id !== id);
          // Update the state with the new array of forms
          setForms(updatedForms);

          console.log(updatedForms);
        }
      };


      const [isRequestorABeneficiary, setIsRequestorABeneficiary] = useState(false);
      const handleCheckboxChange = (event) => {
        setIsRequestorABeneficiary(event.target.checked);
      };

      
    useEffect(() => {
        console.log(forms);
    }, [forms])



    const handleBpBeneficiaryChange = (id, beneficiaryData) => {
        setForms(prevForms => {
            return prevForms.map(form => {
                // Check if the current form's ID matches the ID passed to the function
                if (form.id === id) {
                    // If the ID matches, update the form with the new beneficiary data and return because it is reactJS
                    return {
                        ...form,
                        ...beneficiaryData
                    };
                } else {
                    return form;
                }
            });
        });
    };

    const legalDocuments = [
        "DEED OF DONATION",
        "AFFIDAVIT OF LOSS",
        "NON-DISCLOSURE AGREEMENT",
        "SECRETARY'S CERTIFICATE",
        "TITLE YOUR DOCUMENT"
    ]



    return (
      <>
        <div className="container-xxl flex-grow-1 container-p-y">
          <h4 className="py-3 mb-4">
            <span className="text-muted fw-light">Transaction /</span>
            <span> Add</span>
          </h4>

          <div className="row">
            <div>
              {successMessage && (
                <div style={{ color: "green" }}>{successMessage}</div>
              )}

              {errorMessage && errorMessage.errors && (
                <div
                  className="alert alert-danger alert-dismissible"
                  role="alert"
                >
                  <h6 className="alert-heading d-flex align-items-center mb-1">
                    Error!!
                  </h6>
                  <ul className="ps-0">
                    <div className="row">
                      {Object.entries(errorMessage.errors).map(
                        ([errorKey, errorMessages], index) => (
                          <div key={index} className="col-6">
                            <p className="mb-0">
                              {" "}
                              <span className="text-black">
                                {formatFieldName(errorKey)}
                              </span>{" "}
                              {errorMessages}
                            </p>
                          </div>
                        )
                      )}
                    </div>
                  </ul>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="alert"
                    aria-label="Close"
                  />
                </div>
              )}
            </div>

            <div className="col-12 col-lg-12">
              <div className="card mb-4">
                <div className="card-header">
                  <h5 className="card-title mb-0  text-info">
                    TYPE OF LEGAL DOCUMENT
                  </h5>
                </div>
                <div className="card-body">
                  <div className="row">
                    <div className="mb-3 col-md-6 ecommerce-select2-dropdown">
                      <label className="form-label text-info mb-1" htmlFor="sel_legal_document" >
                        Document
                      </label>
                      <select
                        id="sel_legal_document"
                        className="select2 form-select"
                        data-placeholder="Select Certificate"
                        value={certificateType}
                        name="cert_type"
                        onChange={handleCertificate}
                      >
                        <option value="">Select Legal Documents</option>
                        {legalDocuments.map((document, index) => (
                          <option key={index} value={document}>
                            {document}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="mb-3 col-md-6">
                      {certificateType.toUpperCase() === "TITLE YOUR DOCUMENT" && (
                        <>
                          <div className="col-12 mb-2">
                            <label className="form-label text-info" htmlFor="txtDocumentTitle" >
                                Document Title
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="txtDocumentTitle"
                              value={transferAddress}
                              name="transfer_address"
                              placeholder="Enter title of your document"
                              aria-label="Document Title"
                              onChange={(e) =>
                                setTransferAddress(e.target.value)
                              }
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>



          <div className="card mb-4 scroll-div col ">
              <div className="card-header">
                <h5 className="card-title m-0 text-info">
                    SELECT THE RIGHT ANSWER FOR EACH QUESTION
                </h5>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        name="rad_certificate_for"
                        className="form-check-input"
                        type="radio"
                        value="self"
                        checked={requestFor === "self"}
                        onChange={handleOnchangeRequesttFor}
                        defaultValue
                        id="rad_certificate_for_1"
                        defaultChecked
                      />
                      <label className="form-check-label" htmlFor="rad_certificate_for_1" >
                        Own Certificate
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        name="rad_certificate_for"
                        className="form-check-input"
                        type="radio"
                        value="other"
                        checked={requestFor === "other"}
                        onChange={handleOnchangeRequesttFor}
                        defaultValue
                        id="rad_certificate_for_2"
                      />
                      <label className="form-check-label" htmlFor="rad_certificate_for_2" >
                        For someone else
                      </label>
                    </div>
                  </div>
                </div>
              </div>
          </div>



          {!selectedPurpose?.with_requesting_for && (
            <div className="card mb-4 scroll-div col ">
              <div className="card-header">
                <h5 className="card-title m-0 text-info">
                    {`ARE YOU REQUESTING FOR HIS/HER OWN ${certificateType.toUpperCase()} OR FOR SOMEONE ELSE ?`}
                </h5>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-md-12">
                    <div className="form-check">
                      <input
                        name="rad_certificate_for"
                        className="form-check-input"
                        type="radio"
                        value="self"
                        checked={requestFor === "self"}
                        onChange={handleOnchangeRequesttFor}
                        defaultValue
                        id="rad_certificate_for_1"
                        defaultChecked
                      />
                      <label className="form-check-label" htmlFor="rad_certificate_for_1" >
                        Own Certificate
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        name="rad_certificate_for"
                        className="form-check-input"
                        type="radio"
                        value="other"
                        checked={requestFor === "other"}
                        onChange={handleOnchangeRequesttFor}
                        defaultValue
                        id="rad_certificate_for_2"
                      />
                      <label className="form-check-label" htmlFor="rad_certificate_for_2" >
                        For someone else
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {(requestFor == "other" ||
            selectedPurpose?.with_relationship_to_beneficiary === "true") && (
            <div className="card mb-4 scroll-div col" id="div_to_scroll_1">
              <div className="card-header">
                <h5 className="card-title m-0 text-info">
                  RELATIONSHIP OF REQUESTOR TO{" "}
                  {certPurpose.toLowerCase() === "family home"
                    ? "DECEASED"
                    : "BENEFICIARY"}
                </h5>
              </div>
              <div className="card-body">
                <div className="row g-3">
                  <div className="col-12">
                    <select
                      id="sel_relationship"
                      className="select2 form-select"
                      data-placeholder="Relationship"
                      name="sel_relationship"
                      value={relationshipToBeneficiary}
                      onChange={(e) =>
                        setRelationshipToBeneficiary(e.target.value)
                      }
                    >
                      <option value="">Select Relationship</option>
                      {certPurpose.toLowerCase() === "cohabitation" ? (
                        <option value="Live-in Partner">Live-in Partner</option>
                      ) : (
                        <>
                          <option value="Mother">Mother</option>
                          <option value="Father">Father</option>
                          <option value="Spouse">Spouse</option>
                          <option value="Child">Child</option>
                          <option value="Sibling">Sibling</option>
                          <option value="Grandfather">Grandfather</option>
                          <option value="Grandmother">Grandmother</option>
                          <option value="Grandchild">Grandchild</option>
                          <option value="Aunt/Uncle">Aunt/Uncle</option>
                          <option value="Niece/Nephew">Niece/Nephew</option>
                          <option value="Cousin">Cousin</option>
                          <option value="Guardian">Guardian</option>
                          <option value="Foster Parent">Foster Parent</option>
                          <option value="Foster Child">Foster Child</option>
                          <option value="Step Parent">Step Parent</option>
                          <option value="Step Child">Step Child</option>
                          <option value="Adoptive Parent">
                            Adoptive Parent
                          </option>
                          <option value="Adopted Child">Adopted Child</option>
                          <option value="Neighbor">Neighbor</option>
                        </>
                      )}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="row"></div>

          {certificateType && certPurpose && (
            <div>
              <div className="d-flex flex-wrap justify-content-between align-items-center">
                <div className="d-flex flex-column justify-content-center">
                  <h4 className="mb-1 mt-3">ADDITIONAL INFORMATION</h4>
                  <p className="text-muted">enter additional details</p>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-lg-6">
                  {selectedPurpose &&
                    selectedPurpose.with_picture === "true" && (
                      <ImageCapture onImageChange={handleImageChange} />
                    )}

                  <div className="card mb-4">
                    <div className="card-header">
                      <h5 className="card-title mb-0 text-info">
                        ADDITIONAL INFO
                      </h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        {certPurpose.toLowerCase() === "visa extension" && (
                          <>
                            <div className="col-md-6 mb-2">
                              <label
                                className="form-label  text-info"
                                htmlFor="sel_native_of"
                              >
                                Native of
                              </label>
                              <select
                                id="sel_native_of"
                                className="select2 form-select"
                                data-placeholder="Native of"
                                value={nativeOf}
                                name="visa_native_of"
                                onChange={(e) => setNativeOf(e.target.value)}
                              >
                                <option value="">Select Country</option>
                                <option value="Afghanistan">Afghanistan</option>
                                <option value="Albania">Albania</option>
                                <option value="Algeria">Algeria</option>
                                <option value="Andorra">Andorra</option>
                                <option value="Angola">Angola</option>
                                <option value="Antigua and Barbuda">
                                  Antigua and Barbuda
                                </option>
                                <option value="Argentina">Argentina</option>
                                <option value="Armenia">Armenia</option>
                                <option value="Australia">Australia</option>
                                <option value="Austria">Austria</option>
                                <option value="Azerbaijan">Azerbaijan</option>
                                <option value="Bahamas">Bahamas</option>
                                <option value="Bahrain">Bahrain</option>
                                <option value="Bangladesh">Bangladesh</option>
                                <option value="Barbados">Barbados</option>
                                <option value="Belarus">Belarus</option>
                                <option value="Belgium">Belgium</option>
                                <option value="Belize">Belize</option>
                                <option value="Benin">Benin</option>
                                <option value="Bhutan">Bhutan</option>
                                <option value="Bolivia">Bolivia</option>
                                <option value="Bosnia and Herzegovina">
                                  Bosnia and Herzegovina
                                </option>
                                <option value="Botswana">Botswana</option>
                                <option value="Brazil">Brazil</option>
                                <option value="Brunei">Brunei</option>
                                <option value="Bulgaria">Bulgaria</option>
                                <option value="Burkina Faso">
                                  Burkina Faso
                                </option>
                                <option value="Burundi">Burundi</option>
                                <option value="Cabo Verde">Cabo Verde</option>
                                <option value="Cambodia">Cambodia</option>
                                <option value="Cameroon">Cameroon</option>
                                <option value="Canada">Canada</option>
                                <option value="Central African Republic">
                                  Central African Republic
                                </option>
                                <option value="Chad">Chad</option>
                                <option value="Chile">Chile</option>
                                <option value="China">China</option>
                                <option value="Colombia">Colombia</option>
                                <option value="Comoros">Comoros</option>
                                <option value="Congo, Democratic Republic of the">
                                  Congo, Democratic Republic of the
                                </option>
                                <option value="Congo, Republic of the">
                                  Congo, Republic of the
                                </option>
                                <option value="Costa Rica">Costa Rica</option>
                                <option value="Croatia">Croatia</option>
                                <option value="Cuba">Cuba</option>
                                <option value="Cyprus">Cyprus</option>
                                <option value="Czech Republic">
                                  Czech Republic
                                </option>
                                <option value="Denmark">Denmark</option>
                                <option value="Djibouti">Djibouti</option>
                                <option value="Dominica">Dominica</option>
                                <option value="Dominican Republic">
                                  Dominican Republic
                                </option>
                                <option value="East Timor">East Timor</option>
                                <option value="Ecuador">Ecuador</option>
                                <option value="Egypt">Egypt</option>
                                <option value="El Salvador">El Salvador</option>
                                <option value="Equatorial Guinea">
                                  Equatorial Guinea
                                </option>
                                <option value="Eritrea">Eritrea</option>
                                <option value="Estonia">Estonia</option>
                                <option value="Eswatini">Eswatini</option>
                                <option value="Ethiopia">Ethiopia</option>
                                <option value="Fiji">Fiji</option>
                                <option value="Finland">Finland</option>
                                <option value="France">France</option>
                                <option value="Gabon">Gabon</option>
                                <option value="Gambia">Gambia</option>
                                <option value="Georgia">Georgia</option>
                                <option value="Germany">Germany</option>
                                <option value="Ghana">Ghana</option>
                                <option value="Greece">Greece</option>
                                <option value="Grenada">Grenada</option>
                                <option value="Guatemala">Guatemala</option>
                                <option value="Guinea">Guinea</option>
                                <option value="Guinea-Bissau">
                                  Guinea-Bissau
                                </option>
                                <option value="Guyana">Guyana</option>
                                <option value="Haiti">Haiti</option>
                                <option value="Honduras">Honduras</option>
                                <option value="Hungary">Hungary</option>
                                <option value="Iceland">Iceland</option>
                                <option value="India">India</option>
                                <option value="Indonesia">Indonesia</option>
                                <option value="Iran">Iran</option>
                                <option value="Iraq">Iraq</option>
                                <option value="Ireland">Ireland</option>
                                <option value="Israel">Israel</option>
                                <option value="Italy">Italy</option>
                                <option value="Ivory Coast">Ivory Coast</option>
                                <option value="Jamaica">Jamaica</option>
                                <option value="Japan">Japan</option>
                                <option value="Jordan">Jordan</option>
                                <option value="Kazakhstan">Kazakhstan</option>
                                <option value="Kenya">Kenya</option>
                                <option value="Kiribati">Kiribati</option>
                                <option value="Korea, North">
                                  Korea, North
                                </option>
                                <option value="Korea, South">
                                  Korea, South
                                </option>
                                <option value="Kosovo">Kosovo</option>
                                <option value="Kuwait">Kuwait</option>
                                <option value="Kyrgyzstan">Kyrgyzstan</option>
                                <option value="Laos">Laos</option>
                                <option value="Latvia">Latvia</option>
                                <option value="Lebanon">Lebanon</option>
                                <option value="Lesotho">Lesotho</option>
                                <option value="Liberia">Liberia</option>
                                <option value="Libya">Libya</option>
                                <option value="Liechtenstein">
                                  Liechtenstein
                                </option>
                                <option value="Lithuania">Lithuania</option>
                                <option value="Luxembourg">Luxembourg</option>
                                <option value="Madagascar">Madagascar</option>
                                <option value="Malawi">Malawi</option>
                                <option value="Malaysia">Malaysia</option>
                                <option value="Maldives">Maldives</option>
                                <option value="Mali">Mali</option>
                                <option value="Malta">Malta</option>
                                <option value="Marshall Islands">
                                  Marshall Islands
                                </option>
                                <option value="Mauritania">Mauritania</option>
                                <option value="Mauritius">Mauritius</option>
                                <option value="Mexico">Mexico</option>
                                <option value="Micronesia">Micronesia</option>
                                <option value="Moldova">Moldova</option>
                                <option value="Monaco">Monaco</option>
                                <option value="Mongolia">Mongolia</option>
                                <option value="Montenegro">Montenegro</option>
                                <option value="Morocco">Morocco</option>
                                <option value="Mozambique">Mozambique</option>
                                <option value="Myanmar">Myanmar</option>
                                <option value="Namibia">Namibia</option>
                                <option value="Nauru">Nauru</option>
                                <option value="Nepal">Nepal</option>
                                <option value="Netherlands">Netherlands</option>
                                <option value="New Zealand">New Zealand</option>
                                <option value="Nicaragua">Nicaragua</option>
                                <option value="Niger">Niger</option>
                                <option value="Nigeria">Nigeria</option>
                                <option value="North Macedonia">
                                  North Macedonia
                                </option>
                                <option value="Norway">Norway</option>
                                <option value="Oman">Oman</option>
                                <option value="Pakistan">Pakistan</option>
                                <option value="Palau">Palau</option>
                                <option value="Palestine">Palestine</option>
                                <option value="Panama">Panama</option>
                                <option value="Papua New Guinea">
                                  Papua New Guinea
                                </option>
                                <option value="Paraguay">Paraguay</option>
                                <option value="Peru">Peru</option>
                                <option value="Philippines">Philippines</option>
                                <option value="Poland">Poland</option>
                                <option value="Portugal">Portugal</option>
                                <option value="Qatar">Qatar</option>
                                <option value="Romania">Romania</option>
                                <option value="Russia">Russia</option>
                                <option value="Rwanda">Rwanda</option>
                                <option value="Saint Kitts and Nevis">
                                  Saint Kitts and Nevis
                                </option>
                                <option value="Saint Lucia">Saint Lucia</option>
                                <option value="Saint Vincent and the Grenadines">
                                  Saint Vincent and the Grenadines
                                </option>
                                <option value="Samoa">Samoa</option>
                                <option value="San Marino">San Marino</option>
                                <option value="Sao Tome and Principe">
                                  Sao Tome and Principe
                                </option>
                                <option value="Saudi Arabia">
                                  Saudi Arabia
                                </option>
                                <option value="Senegal">Senegal</option>
                                <option value="Serbia">Serbia</option>
                                <option value="Seychelles">Seychelles</option>
                                <option value="Sierra Leone">
                                  Sierra Leone
                                </option>
                                <option value="Singapore">Singapore</option>
                                <option value="Slovakia">Slovakia</option>
                                <option value="Slovenia">Slovenia</option>
                                <option value="Solomon Islands">
                                  Solomon Islands
                                </option>
                                <option value="Somalia">Somalia</option>
                                <option value="South Africa">
                                  South Africa
                                </option>
                                <option value="South Sudan">South Sudan</option>
                                <option value="Spain">Spain</option>
                                <option value="Sri Lanka">Sri Lanka</option>
                                <option value="Sudan">Sudan</option>
                                <option value="Suriname">Suriname</option>
                                <option value="Sweden">Sweden</option>
                                <option value="Switzerland">Switzerland</option>
                                <option value="Syria">Syria</option>
                                <option value="Taiwan">Taiwan</option>
                                <option value="Tajikistan">Tajikistan</option>
                                <option value="Tanzania">Tanzania</option>
                                <option value="Thailand">Thailand</option>
                                <option value="Togo">Togo</option>
                                <option value="Tonga">Tonga</option>
                                <option value="Trinidad and Tobago">
                                  Trinidad and Tobago
                                </option>
                                <option value="Tunisia">Tunisia</option>
                                <option value="Turkey">Turkey</option>
                                <option value="Turkmenistan">
                                  Turkmenistan
                                </option>
                                <option value="Tuvalu">Tuvalu</option>
                                <option value="Uganda">Uganda</option>
                                <option value="Ukraine">Ukraine</option>
                                <option value="United Arab Emirates">
                                  United Arab Emirates
                                </option>
                                <option value="United Kingdom">
                                  United Kingdom
                                </option>
                                <option value="United States">
                                  United States
                                </option>
                                <option value="Uruguay">Uruguay</option>
                                <option value="Uzbekistan">Uzbekistan</option>
                                <option value="Vanuatu">Vanuatu</option>
                                <option value="Vatican City">
                                  Vatican City
                                </option>
                                <option value="Venezuela">Venezuela</option>
                                <option value="Vietnam">Vietnam</option>
                                <option value="Yemen">Yemen</option>
                                <option value="Zambia">Zambia</option>
                                <option value="Zimbabwe">Zimbabwe</option>
                              </select>
                            </div>

                            <div className="col-12 col-md-6 mb-2">
                              <label
                                className="form-label text-info mb-0"
                                htmlFor="dp_staying_since"
                              >
                                Staying Since
                              </label>

                              <DatePicker
                                id="dp_staying_since"
                                name="visa_staying_since"
                                className="form-control flatpickr-input active"
                                placeholderText="YYYY-MM-DD"
                                selected={
                                  stayingSince ? new Date(stayingSince) : null
                                }
                                onChange={(date) => {
                                  handleDateChangeStayingSince(date);
                                }}
                                dateFormat="yyyy-MM-dd"
                              />
                            </div>

                            <div className="col-md-6 mb-2">
                              <label className="form-label text-info" htmlFor="txt_reason_of_staying" >
                                Reason of Staying
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                id="txt_reason_of_staying"
                                value={reasonOfStaying}
                                name="visa_reason_of_staying"
                                placeholder="Ex: rendering missionary service under the Missionary Servants of the Blessed Sacrament"
                                aria-label="Reason of Staying"
                                onChange={(e) =>
                                  setReasonOfStaying(e.target.value)
                                }
                              />
                            </div>
                          </>
                        )}

                        {certPurpose.toLowerCase() === "transfer address" && (
                          <>
                            <div className="col-12 mb-2">
                              <label className="form-label text-info" htmlFor="txt_transfer_address" > Current Address </label>
                              <input
                                type="text"
                                className="form-control"
                                id="txt_transfer_address"
                                value={transferAddress}
                                name="transfer_address"
                                placeholder="Current Address"
                                aria-label="Current Address"
                                onChange={(e) =>
                                  setTransferAddress(e.target.value)
                                }
                              />
                            </div>
                          </>
                        )}

                        {certPurpose.toLowerCase() === "balik probinsya" && (
                          <>
                            <div className="col-12 mb-2">
                              <label className="form-label text-info" htmlFor="txt_balik_probinsya_address" > Address of all Beneficiaries </label>
                              <input
                                type="text"
                                className="form-control"
                                id="txt_balik_probinsya_address"
                                value={balikProbinsyaAddress}
                                name="balik_probinsya_address"
                                placeholder="Current Address of Beneficiaries"
                                aria-label="Current Address"
                                onChange={(e) =>
                                  setBalikProbinsyaAddress(e.target.value)
                                }
                              />
                            </div>

                            <div className="col">
                              <label className="form-label  text-info" htmlFor="sel_province" >
                                Province to go back
                              </label>
                              <select
                                id="sel_balik_probinsya_address_province"
                                className="select2 form-select"
                                data-placeholder="Province"
                                value={balikProbinsyaAddressProvince}
                                name="balik_probinsya_address_province"
                                onChange={(e) =>
                                  setBalikProbinsyaAddressProvince(
                                    e.target.value
                                  )
                                }
                              >
                                <option value="">Select Province</option>
                                {provinceList.map((prov, index) => (
                                  <option key={index} value={prov}>
                                    {prov}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </>
                        )}

                        {selectedPurpose &&
                          selectedPurpose.with_partner_since === "true" && (
                            <>
                              <div className="col-md-12 mb-2">
                                <label className="form-label text-info" htmlFor="txt_cohabitation_address" >
                                  Current Living Address
                                </label>
                                <input
                                  id="txt_cohabitation_address"
                                  name="cohabitation_address"
                                  value={cohabitationAddress}
                                  onChange={(e) =>
                                    setCohabitationAddress(e.target.value)
                                  }
                                  className="form-control"
                                  placeholder="Current living address"
                                />
                              </div>
                              <div className="col-md-6 mb-2">
                                <label className="form-label text-info" htmlFor="sel_resident_since" >
                                  Partner Since
                                </label>
                                <select
                                  id="sel_partner_since"
                                  name="sel_resident_since"
                                  value={partnertSince}
                                  onChange={(e) =>
                                    handlePartnerChange(e.target.value)
                                  }
                                  className="select2 form-select"
                                  data-placeholder="Partner Since"
                                >
                                  <option value="">Select Year</option>

                                  {years.map((year) => (
                                    <option key={year} value={year}>
                                      {year}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </>
                          )}

                        {certPurpose.toLowerCase() ==
                          "estate tax residency" && (
                          <div className="col-md-6">
                            <label className="form-label text-info mb-2" htmlFor="dp_date_of_death" >
                              Date of Death
                            </label>

                            <DatePicker
                              id="dp_date_of_death"
                              name="estate_tax_date_of_death"
                              className="form-control flatpickr-input active"
                              placeholderText="YYYY-MM-DD"
                              selected={dateOfDeath}
                              onChange={(date) => {
                                handleDateChangeDateOfDeath(date);
                              }}
                              dateFormat="yyyy-MM-dd"
                            />
                          </div>
                        )}

                        {selectedPurpose &&
                          selectedPurpose.with_residence_since === "true" && (
                            <div className="col-md-6 mb-2">
                              <label className="form-label text-info" htmlFor="sel_resident_since" >
                                Resident Since
                              </label>
                              <select id="sel_resident_since" name="sel_resident_since" value={residentSince} onChange={(e) => handleResidentChange(e.target.value) } className="select2 form-select" data-placeholder="Resident Since" >
                                <option value="">Select Year</option>

                                {years.map((year) => (
                                  <option key={year} value={year}>
                                    {year}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}

                        <div className="col">
                          <label className="form-label  text-info" htmlFor="txt_address" >
                            Remarks
                          </label>
                          <textarea
                            id="txt_remarks"
                            className="form-control"
                            placeholder="Remarks"
                            value={remarks}
                            name="cert_remarks"
                            onChange={(e) => setRemarks(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-lg-6">
                  <div className="card">
                    <div className="card-header">
                      <h5 className="card-title text-info mb-0">PAYMENT</h5>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="mb-3 col-md-12">
                          <label className="form-label text-info">
                            Certificate Amount
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            step="0.1"
                            min={0}
                            placeholder="Price"
                            name="cert_amount"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                          />
                        </div>
                        <div className="mb-3 col-md-12">
                          <label className="form-label text-info">
                            Discount
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            step="0.1"
                            min={0}
                            placeholder="Discounted Price"
                            name="cert_discount"
                            value={discount}
                            onChange={(e) => setDiscount(e.target.value)}
                          />
                        </div>
                        <div className="form-check mb-2 d-none">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue
                            id="price-charge-tax"
                            defaultChecked
                          />
                          <label className="form-label">
                            {" "}
                            Charge tax on this product{" "}
                          </label>
                        </div>
                        <div className="d-flex justify-content-between align-items-center border-top pt-3 d-none">
                          <span className="mb-0 h6">In stock</span>
                          <div className="w-25 d-flex justify-content-end">
                            <label className="switch switch-primary switch-sm me-4 pe-2">
                              <input
                                type="checkbox"
                                className="switch-input"
                                defaultChecked
                              />
                              <span className="switch-toggle-slider">
                                <span className="switch-on">
                                  <span className="switch-off" />
                                </span>
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="d-flex flex-wrap justify-content-end align-items-center mt-3">
                    <div className="d-flex align-content-center flex-wrap gap-3">
                      <button className="btn btn-label-secondary d-none">
                        Discard
                      </button>
                      <button className="btn btn-label-primary d-none">
                        Save as draft
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSubmit}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </>
    );
}

export default TechOathAmplifyAdd;